module.exports = __webpack_public_path__ + "img/tripadvisor.9dfb03a9.svg";